"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M14 11H8.5C8.293 11 8.176 11.235 8.299 11.4L8.8 12.4C9.131 12.842 9.042 13.469 8.6 13.8C8.157 14.131 7.531 14.042 7.2 13.6L5.2 10.6C5.188 10.583 5.187 10.564 5.176 10.548C5.152 10.514 5.133 10.48 5.115 10.443C5.093 10.401 5.078 10.358 5.063 10.312C5.049 10.271 5.035 10.231 5.026 10.189C5.019 10.148 5.017 10.109 5.014 10.067C5.012 10.044 5 10.024 5 10C5 9.976 5.012 9.956 5.014 9.933C5.017 9.891 5.019 9.852 5.026 9.811C5.035 9.769 5.049 9.729 5.063 9.688C5.078 9.643 5.093 9.599 5.115 9.557C5.133 9.52 5.152 9.486 5.176 9.452C5.187 9.436 5.188 9.417 5.2 9.4L7.2 6.4C7.396 6.138 7.697 6 8.001 6C8.209 6 8.42 6.065 8.6 6.2C9.042 6.531 9.131 7.158 8.8 7.6L8.299 8.6C8.176 8.765 8.293 9 8.5 9H14C14.552 9 15 9.447 15 10C15 10.553 14.552 11 14 11ZM10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2Z",
    fill: "#727B7F"
  }));
};